import { useTranslation } from 'react-i18next';
import { Icon } from '@sdb/planning-ui';

import { getEntityIcon } from 'components/mrp/mrp.utils';

import { OrganizationalUnitIcon } from '../../PlanningEntityPicker.styles';
import {
  getOrganizationalUnitIconType,
  getSelectionLabel
} from '../../PlanningEntityPicker.utils';
import SelectionChip from '../SelectionChip';

import type { PlanningEntityChipProps } from './PlanningEntityChip.types';

/** One picked person ("12 - Jan Jansen") or plan unit ("Afdeling Noord · patiënten"), with ✕ to remove it. */
const PlanningEntityChip = ({
  selection,
  onRemove
}: PlanningEntityChipProps) => {
  'use memo';

  const { t } = useTranslation('common');

  const label = getSelectionLabel(selection, t);

  const icon =
    selection.kind === 'ENTITY' ? (
      getEntityIcon(
        selection.planningEntity.planningEntityType,
        undefined,
        'SMALL',
        true
      )
    ) : (
      <OrganizationalUnitIcon compact>
        <Icon
          type={getOrganizationalUnitIconType(selection.organizationalUnitId)}
          fontSize="small"
        />
      </OrganizationalUnitIcon>
    );

  return (
    <SelectionChip
      icon={icon}
      label={label}
      removeLabel={t('planningEntityPicker.removeLabel', { name: label })}
      onRemove={() => onRemove(selection)}
    />
  );
};

export default PlanningEntityChip;
